export default {"src":"/_next/static/media/close.70a61783.svg","height":10,"width":10};